import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { BreadcrumbItemProps } from '@/features/admin/components/AdminPageHeader';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { TestAssignmentsRoot } from '@/features/test-assignments/components/TestAssignmentsRoot';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const testAssignmentsSearchParams = z.object({
  page: fallback(z.number(), 0),
  perPage: fallback(z.number(), 10),
  studentId: fallback(z.string(), ''),
  subject: fallback(z.string(), ''),
  grade: fallback(z.string(), ''),
  status: fallback(z.string(), ''),
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Home',
    link: { to: '/app' },
  },
  {
    label: 'Administration',
    link: { to: '/app' },
  },
  {
    label: 'Test Assignments',
    link: { to: '/app/admin-section/test-assignments' },
  },
];

export const Route = createFileRoute(
  '/_app/app/admin-section/test-assignments'
)({
  component: RouteComponent,
  validateSearch: zodValidator(testAssignmentsSearchParams),
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR, UserRoles.AIDE]),
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AppPageContent>
        <AppPageHeader breadcrumbItems={breadcrumbItems} />
        <TestAssignmentsRoot />
      </AppPageContent>
    </>
  );
}
